import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import AboutUs from "../components/about/AbousUs";
import visionImage from "../assets/new-ui/vision/vision-image.png";
import sharkAres from "../assets/new-ui/vision/Ares.gif";
import { useEffect } from "react";
import ConnectWallet from "../components/ConnectWallet";
import Bubble from "../components/coral/Bubble";
import CoralLeftType1 from "../components/coral/CoralLeftType1";
import EconomyGraph from "../components/economy/EconomyGraph";

export default function Vision() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pageContainer visionContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />

      <div className="header">
        <div className="visionHeader">
          <div className="description">
            <div>OUR VISION</div>
            <div>
              Hi everyone, as you guys all know, we are the Sharktopia team,
              young people who love technology and aspire to change the world
              for the better. Besides, we want to bring the community
              unforgettable and enjoyable experiences, primarily through
              Sharktopia.
            </div>
            <div>
              We aim to create a closed ecosystem from Farming, Battle, to
              Cross-breeding on the Binance Smart Chain platform.
            </div>
            <div>
              Create a vibrant, exciting, and entertaining playground for users
              to be the real owners of the game.
            </div>
          </div>
        </div>
        <div className="imgHeader">
          <div className="imgDescription">
            <div>
              Unlike other projects, we aim to interact more with the community
              instead of just focusing on revenue.
            </div>
            <div>
              We keep updating new features for the project, trying to bring
              actual outside activities into the game as much as possible to
              create a sense of intimacy for users, such as fishing, farming,
              gathering, and much more!
            </div>
            <div>
              Our members could experience many games such as The Sims, LOL,
              Warcraft, Fortnite, etc. Therefore, we understand well how these
              games work to develop the most appropriate and effective
              mechanism. That's why players can feel the familiarity through
              previous popular games that are easier to accept this game.
            </div>
            <div>
              We always look forward to receiving support from the community to
              make Sharktopia stronger and stronger, not just as a small group
              but as a large community like Discord. And there will always be
              well-deserved rewards for our token holders.
            </div>
          </div>
          <img src={visionImage} alt="desciption" />
        </div>
        <div className="visionPlan">
          <CoralLeftType1 type={"small"} />
          <Bubble top={"-50%"} />
          <div className="ownNFT">
            <div>Why should I own Sharktopia NFT?</div>
            <div>
              Besides their adorableness, lovely and unique, Sharktopia NFT
              owners will be continuously granted items for the in-game world
              via community events.
            </div>
            <div>
              The value of Sharktopia NFT in each sale will increase gradually,
              so the sooner you own it, the more you can buy it at a very
              reasonable price.
            </div>
            <div>
              In addition, users can also receive a passive income from farming
              these NFTs, and these will also be the characters that users will
              use to participate in Arena when the game is released later.
            </div>
          </div>
          <div className="longTerm">
            <div>Long-Term View</div>
            <div>
              We always want to make our games scalable across multiple
              platforms to reach as many users as possible, creating a solid
              community. But now, we realize that BSC is one of the platforms
              with the most popular users and has the cheapest transaction fees.
              Because we always prioritize the community, BSC will be chosen as
              the first platform.
            </div>
            <div>
              To ensure that the value of tokens and NFTs will be worth users'
              efforts, we have designed a suitable ecosystem to avoid possible
              inflation. This not only provides users a playground for
              entertainment but also can earn additional passive income.
            </div>
          </div>
        </div>
        <div className="thankyou">
          <div>THANK YOU</div>
          <div>- Sharktopia Team -</div>
        </div>
      </div>

      <div className="economy">
        <div className="title">OCEAN ECONOMY</div>
        <div className="description">
          Ocean economy features depend on economics principle
        </div>
        <div className="economyFormulaArea">
          {/* <EconomyFormula /> */}
          <div className="formularBox">
            <div className="formularTitle">M x V = P x Q</div>
            <ul>
              <li>M = Money supply of GDC.</li>
              <li>
                V = Velocity of circulation - How fast money changes hands to
                finance transactions in the Ocean economy.
              </li>
              <li>
                P = Price level (NFTs and items of Sharktopia output) as
                represented by the efficiency of the Sharktopia ecosystem.
              </li>
              <li>Q = Quantity NFTs and items of Sharktopia output.</li>
            </ul>
          </div>
        </div>
        <div className="economyGraphArea">
          <EconomyGraph />
        </div>
      </div>

      <div className="about">
        <Bubble top={"30%"} />
        <div className="aboutIntro">
          {/* <div className='hadesGod'>
            <img src={hadesFire} alt='desciption'/>
            <img src={sharkHades} alt='desciption'/>
          </div> */}
          <img src={sharkAres} alt="desciption" />
          <div className="aboutDetail">
            <div>ABOUT US</div>
            <div>
              Hi everyone, we are a multinational team from many different
              countries, mainly in Asia and Europe. The core team consists of
              four developers, two designers, one marketer, and one financial
              advisor. Most of them have worked at many leading companies in the
              software and creative fields.
            </div>
            <div>
              With a passion for the blockchain market and having experience in
              this market since 2016, besides realizing this market's potential
              and robust movement, we decided to launch this project as a
              startup and a playground for the community. In this project, users
              will be immersed in an ocean world, own items, generate passive
              income, and become a part of the game.
            </div>
          </div>
        </div>
        <AboutUs />
      </div>
      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
